import { SxProps, Theme } from "@mui/system";

export const rulesLeftCell: SxProps<Theme> = {
  "&.MuiTableCell-root.MuiTableCell-root": {
    fontFamily: "Inter",
    width: "50%",
  },
  borderRight: "3px solid black",
  textAlign: "left",
  verticalAlign: "top",
  padding: "2px",
};

export const rulesRightCell: SxProps<Theme> = {
  "&.MuiTableCell-root.MuiTableCell-root": {
    fontFamily: "Inter",
    fontSize: "10px",
  },
  textAlign: "left",
  verticalAlign: "top",
  padding: "2px",
};

export const signaturesLeftCell: SxProps<Theme> = {
  "&.MuiTableCell-root.MuiTableCell-root": {
    fontFamily: "Inter",
  },
  borderRight: "3px solid black",
  textAlign: "center",
  width: "50%",
  padding: "2px",
  fontSize: "10px",
};

export const signaturesRightCell: SxProps<Theme> = {
  "&.MuiTableCell-root.MuiTableCell-root": {
    fontFamily: "Inter",
  },
  textAlign: "center",
  padding: "2px",
  fontSize: "11px",
};

export const emptyRowCell: SxProps<Theme> = {
  borderRight: "3px solid black",
  height: "100px",
};
export const emptyRowCellRight: SxProps<Theme> = {
  height: "100px",
};

export const rowBorderStyle = {
  borderBottom: "3px solid black",
};

export const signResize = {
  width: "150px",

  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
};
